import React, { useEffect } from 'react'
import styled from 'styled-components'
import { GridItem } from '@zuto/core/src/grid'
import Box from '../../../packages/core/src/box'
import { fireReactGAEvent } from '../Questions/utils'

const StyledLink = styled(Box)`
    text-decoration: none;
`

const CannotProceed = () => {
  useEffect(() => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'Cannot Proceed',
      label: 'VehicleType'
    })
  }, [])
  return (
    <>
      <GridItem gridColumn={['auto / span 12', '3 / span 8']} mt={6}>
        <Box as="h1" mt={[6, 0]} mb={4} textStyle="display.large.medium">Get in touch</Box>
        <Box textStyle="body.regular.regular">
          To proceed with your application for this type of vehicle,
          please give us a call on
          <StyledLink as="a" textStyle="body.regular.medium" color="secondary.1" href="tel:01625619944"> 01625 619944 </StyledLink>
          and a member of our team will be able to discuss your options.
        </Box>
        <Box textStyle="body.regular.regular" mt={5}>
          For more help, please visit
          <StyledLink as="a" textStyle="body.regular.medium" color="secondary.1" href="/"> zuto.com</StyledLink>
        </Box>
      </GridItem>
    </>
  )
}

export default CannotProceed
